export const getSubdomain = () => {};
